export default __webpack_public_path__ + "static/media/AAA dark.cb1565e7.svg";